import { render, staticRenderFns } from "./SafeReport.vue?vue&type=template&id=73332478"
import script from "./SafeReport.vue?vue&type=script&lang=js"
export * from "./SafeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports